/**
 * Recipient invitation inbox: status buckets, sort keys, and page size
 * shared by the list API and the sidebar panel.
 *
 * @module constants/invite-inbox
 */
export const INVITE_INBOX_BUCKETS = ['pending', 'declined', 'expired', 'accepted'];
export const INVITE_INBOX_SORTS = ['createdAt', 'expiresAt', 'name'];
export const INVITE_INBOX_SORT_DIRS = ['asc', 'desc'];
export const INVITE_INBOX_TYPES = ['space', 'group'];
/** Max rows returned for one inbox page. */
export const INVITE_INBOX_PAGE_SIZE = 20;
/**
 * Safety cap on sort-key scans so a huge history cannot unbounded-scan.
 * Matches the order of magnitude of pending-invite list caps.
 */
export const INVITE_INBOX_SCAN_CAP = 500;
//# sourceMappingURL=invite-inbox.js.map